import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { X, Download, Smartphone } from 'lucide-react';

/**
 * PWA Install Prompt - Android Chrome ve Desktop'ta "Ana ekrana ekle" teklifi
 * iOS Safari Capacitor ile uygulamamızı kullanacağı için burada göstermiyoruz
 */
export default function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Kullanıcı daha önce "reddet" dediyse gösterme
      const dismissed = localStorage.getItem('pwa-install-dismissed');
      if (dismissed) {
        const days = (Date.now() - parseInt(dismissed)) / (1000 * 60 * 60 * 24);
        if (days < 7) return;
      }
      setTimeout(() => setShow(true), 3000); // 3 sn sonra göster
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setShow(false);
    }
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    localStorage.setItem('pwa-install-dismissed', Date.now().toString());
    setShow(false);
  };

  if (!show || !deferredPrompt) return null;

  return (
    <div className="fixed bottom-24 right-5 z-40 max-w-sm bg-white rounded-2xl shadow-2xl border p-3 flex items-center gap-3"
      data-testid="pwa-install-prompt">
      <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
        <Smartphone className="h-5 w-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm">Telefonunuza ekleyin</div>
        <div className="text-xs text-slate-500">Daha hızlı erişim + bildirimler</div>
      </div>
      <Button size="sm" onClick={install} data-testid="pwa-install-btn">
        <Download className="h-3.5 w-3.5 mr-1" />Kur
      </Button>
      <button onClick={dismiss} className="p-1 text-slate-400 hover:text-slate-600">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
